import axios from 'axios';
import Config from 'config';

export const requestInterceptors = [
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
];

export const responseInterceptors = [
  (response) => response,
  (error) => {
    if (error && error.response) {
      if (error.response.status === 401) {
        // if (process.env.REACT_APP_NODE_ENVIRONMENT !== 'local') {
        //   window.location.reload();
        // }
        // window.location.href = '/login';

        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
];

const authIntance = axios.create({
  timeout: 60000,
  baseURL: Config.getValue('REACT_APP_AUTHENTICATION_API') || '/api',
  headers: {
    ContentType: 'application/json'
  }
});

authIntance.interceptors.request.use(...requestInterceptors);
authIntance.interceptors.response.use(...responseInterceptors);

export default authIntance;
